<template>
  <div>
    <site-header>
      <h1>Get in contact</h1>
    </site-header>

    <main :class="$style.contact" class="wrap">
      <p :class="$style.intro">Please do not hesitate to get in touch with me using the form below or <a href="mailto:r.blything@gmail.com?subject=Work%20enquiry">sending an email</a> to discuss your design ideas; pre-production sound needs; sound effects available from my library, specific field sound requirements or any sound editing projects, I’ll be pleased to get involved.</p>
      <form :class="$style.form" action="https://formspree.io/r.blything@gmail.com" method="POST">
        <label>
          <span>Name</span>
          <input type="text" name="_gotcha" style="display:none">
          <input type="text" name="name">
        </label>
        <label>
          <span>Email address (required)</span>
          <input type="email" name="email" required>
        </label>
        <label>
          <span>How can I help you?</span>
          <textarea ref="enquiry" name="enquiry" rows="1" required=""></textarea>
        </label>
        <input type="hidden" name="_subject" value="Contact enquiry from rickblything.net">
        <input type="hidden" name="_next" value="/about">

        <button type="submit">Send</button>
      </form>
    </main>
  </div>
</template>

<script>
  import autosize from 'autosize';
  import SiteHeader from '../components/SiteHeader';

  export default {
    name: 'contact',

    components: {
      SiteHeader,
    },

    head: {
      title() {
        return {
          inner: 'Get in contact',
        };
      },
    },

    mounted() {
      autosize(this.$refs.enquiry);
    },
  };
</script>

<style module lang="postcss">
  .contact {
    padding-right: 1rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    max-width: 62.5rem;

    @media (width >= 50em) {
      padding-right: 4rem;
      padding-left: 4rem;
    }
  }

  .intro {
    margin-bottom: 3rem;
  }

  .form {
    & label,
    & span {
      display: block;
      width: 100%;
      max-width: 30rem;
    }

    & label {
      margin-bottom: 2rem;
      cursor: pointer;
    }

    & span {
      margin-bottom: 0.75rem;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1.2;
      letter-spacing: 0.05rem;
      text-indent: 0.05rem;
      text-transform: uppercase;
      color: #444;
    }

    & input {
      font-size: 1.4rem;
    }

    & input,
    & textarea {
      border: 0;
      padding: 1rem;
      width: 100%;
      font-family: 'franklin-gothic-urw', sans-serif;
      background-color: #f8f8f8;

      &:focus {
        box-shadow: 0 3px 0 0 #000;
        outline: 0;
        background-color: #f4f4f4;
      }
    }

    & button {
      -webkit-appearance: none;
      padding: 0.75rem 1.5rem;
      font-family: 'franklin-gothic-urw', sans-serif;
      font-size: 1.3rem;
      background-color: #000;
      color: #fff;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?32aa44bc